import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { formatDate } from '@telerik/kendo-intl';
import moment from 'moment';

interface DateCellProps extends GridCellProps {
  dateOnly: boolean;
}

const DateCell: FC<React.PropsWithChildren<DateCellProps>> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style, field, format, dateOnly }) => {
  const hoursToAdd = dateOnly ? 8 : 0;
  const adjustedDate = dataItem[field] == null ? null : moment(dataItem[field]).add(hoursToAdd, 'hours').toDate();

  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected={isSelected}
      data-grid-col-index={columnIndex}
      style={{ ...style, textAlign: 'left' }}
    >
      {formatDate(adjustedDate, format)}
    </td>
  );
};

export default DateCell;